import { useAuth0 } from "@auth0/auth0-react";
import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../../api-client";
const EMPLOYEE_KEY = "EMPLOYEE";

const useEmployment = () => {
  const { get } = useApiClient();
  const { user } = useAuth0();

  const setUserFromAuth0 = () => {
    if (!user) throw new Error("User is not logged in");

    return {
      employmentId: user.sub,
      companyId: user["https://www.cobee.io/companyId"],
    }
  };

  const getEmployment = async () => {
    try {
      const { data, status } = await get("/v1/employees/employment/me");

      if (status === 204) {
        return setUserFromAuth0();
      }

      return {
        employmentId: data.employmentId,
        companyId: data.companyId,
      }
    } catch (error) {
      return setUserFromAuth0();
    }
  };


  const { data, isLoading } = useQuery({
    queryKey: [EMPLOYEE_KEY],
    queryFn: getEmployment,
  });

  return {
    employmentId: data?.employmentId,
    companyId: data?.companyId,
    isLoading
  };
};

export { useEmployment };
